<template>
<base-modal title="Image upload">
  <form>
    <div class="columns">
      <div class="column">
        <file-input required
          button-text="Choose a file"
          class="is-boxed"
          hint="800px x 600px"
          @select="setFile" 
          :error="errors.file">
          Gallery Image
        </file-input>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <submit-button 
          :working="working" 
          @submit="save" 
          class="is-success is-rounded">
          Save
        </submit-button>
      </div>
    </div>
  </form>
</base-modal>  
</template>

<script>
import { saveFile } from '@/api/gallery'

export default {
    
  props: {
    galleryId: Number
  },

  data: () => ({
    working: false,
    file: ''
  }),

  methods: {
    setFile(file) {
      this.file = file
    },

    save() {
      this.working = true
      saveFile({
        galleryId: this.galleryId,
        file: this.file
      }, () => {
        this.$toast.success('Image saved')
        this.working = false
        this.$close(true)
      }, () => {
        this.working = false
      })
    }
  }

}
</script>
